import { FormState, FieldState } from '../../../../../mainv2/states/FormState';
import { MonthlyGoal } from '../../../../types/goals';
import { RemoteResourceV3, updateRemoteResourceV3 } from '../../../../../commonv3/api/RemoteResourceV3';
import { observable } from 'mobx';
import { GoalsApi } from '../../../../apis/goals';

export class MonthlyGoalFormState extends FormState<MonthlyGoal> {
    @observable currentMonthlyGoal: RemoteResourceV3<MonthlyGoal> = RemoteResourceV3.loading();

    constructor() {
        super({
            goal: new FieldState('', false),
            todos: new FieldState([''], false),
            next_actions: new FieldState([''], false),
            progress: new FieldState(0, false),
            reviews: new FieldState('', false),
            year: new FieldState(2000, false),
            month: new FieldState(1, false),
        });
    }

    async init(year, month) {
        const values = await updateRemoteResourceV3(
            this.currentMonthlyGoal,
            (v) => (this.currentMonthlyGoal = v),
            () => GoalsApi.findMonthlyGoal(year, month)
        );
        if (!values.goal) {
            values.goal = '';
        }
        if (!values.reviews) {
            values.reviews = '';
        }
        if (!values.progress) {
            values.progress = 0;
        }
        if (!values.todos) {
            values.todos = [''];
        } else {
            values.todos.push('');
        }
        if (!values.next_actions) {
            values.next_actions = [''];
        } else {
            values.next_actions.push('');
        }
        this.setValues(values);
    }
}
